module.exports = __webpack_public_path__ + "media/guac_sweepstakes/pinterest-social-icon-1bbc4e33.svg";